interface PageWrapperProps {
  Page: any;
}

export const PageWrapper = ({ Page, ...ownProps }: PageWrapperProps) => {
  return <Page {...ownProps} />;
};
